import React, { useState } from "react";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { sendMessage } from "../servises/websocket";
import { generalMessageTemplate } from "../entities/generalMessageTemplate";
import MobileAccordion from "./MobileAccordion";

const GameSelection = ({ onGameSelected }) => {
  const [selectedGameType, setSelectedGameType] = useState(null);


  const accordionData = [
    {
      title: "One on one buttle",
      buttons: [
        {
          text: "Timeless Clash",
          type: "one_on_one",
          info: "One-on-One: Face off in a duel between two players.",
        },
        {
          text: "Team Battle",
          type: "team_battle",
          info: "Team Battle: Compete with a group of players.",
        },
      ],
    },
    {
      title: "Accordion Item 2",
      buttons: [
        {
          text: "Quick Match",
          type: "quick_match",
        },
        {
          text: "Ranked Match",
          type: "ranked_match",
          info: "Ranked Match: Compete for ranking points.",
        },
      ],
    },
    {
      title: "Accordion Item 3",
      buttons: [
        {
          text: "Casual Game",
          type: "casual_game",
        },
      ],
    },
  ];

  // Popover state
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverText, setPopoverText] = useState("");

  const handlePopoverOpen = (event, text) => {
    setAnchorEl(event.currentTarget);
    setPopoverText(text);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverText("");
  };

  const open = Boolean(anchorEl);

  // Function to handle game type selection
  const handleGameTypeSelection = (gameType) => {
    setSelectedGameType(gameType);

    // Create the generalMessage to send to the server
    const generalMessage = { ...generalMessageTemplate };
    generalMessage.game.gameTeamType = gameType;
    generalMessage.game.gameTimeType = "move_limit";
    generalMessage.messageType = "new_game_request";

    // Send the selected game type to the server via WebSocket
    sendMessage(generalMessage);

    console.log(`Game type selected: ${gameType}`);

    // Notify the parent component to start the game
    if (onGameSelected) {
      onGameSelected();
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "-200px" }}>
      <h1
        style={{
          fontSize: "3rem",
          color: "yellow",
          textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)", // Adds shadow for depth effect
        }}
      >
        Choose Your Battle Format
      </h1>

      <MobileAccordion
        items={accordionData}
        handleGameTypeSelection={(type) => console.log(`Game Type Selected: ${type}`)}
        handlePopoverOpen={(event, info) => console.log(`Info: ${info}`)}
        />;

      <Box sx={{ width: '100%' }}>
        <Stack spacing={2}>
          {/* One-on-One */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <button
              style={{
                width: "300px", // Ensures all buttons have the same width
                padding: "10px 20px",
                fontSize: "1rem",
                cursor: "pointer",
              }}
              onClick={() => handleGameTypeSelection("one_on_one")}
            >
              One-on-One
            </button>
            <InfoOutlinedIcon
              fontSize="large"
              sx={{ marginLeft: 2, cursor: "pointer", color: "yellow" }}
              onClick={(event) =>
                handlePopoverOpen(event, "One-on-One: Face off in a duel between two players.")
              }
            />
          </div>

          {/* Three-on-Three Clash */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <button
              style={{
                width: "300px",
                padding: "10px 20px",
                fontSize: "1rem",
                cursor: "pointer",
              }}
              onClick={() => handleGameTypeSelection("team_3")}
            >
              Three-on-Three Clash
            </button>
            <InfoOutlinedIcon
              fontSize="large"
              sx={{ marginLeft: 2, cursor: "pointer", color: "yellow" }}
              onClick={(event) =>
                handlePopoverOpen(event, "Three-on-Three Clash: Each team has 3 players.")
              }
            />
          </div>

          {/* Five-on-Five Clash */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <button
              style={{
                width: "300px",
                padding: "10px 20px",
                fontSize: "1rem",
                cursor: "pointer",
              }}
              onClick={() => handleGameTypeSelection("team_5")}
            >
              Five-on-Five Clash
            </button>
            <InfoOutlinedIcon
              fontSize="large"
              sx={{ marginLeft: 2, cursor: "pointer", color: "yellow" }}
              onClick={(event) =>
                handlePopoverOpen(event, "Five-on-Five Clash: Each team has 5 players.")
              }
            />
          </div>
        </Stack>
      </Box>

      {/* Popover for info icons */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography>{popoverText}</Typography>
        </Box>
      </Popover>

      {selectedGameType && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 3, // Adds some space above the loading message
          }}
        >
          <CircularProgress size={24} sx={{ marginRight: 2 }} />
          <p>Please wait while we assemble your battle team</p>
        </Box>
      )}
    </div>
  );
};

export default GameSelection;
